import { useIsAuthenticated } from '../useIsAuthenticated';

type Props = {
  skip?: boolean;
};

export const useCurrentAccountId = ({ skip }: Props = {}) => {
  const isSsr = typeof window === 'undefined';
  const { isAuthenticated, error, isLoading } = useIsAuthenticated({
    skip: skip || isSsr,
  });

  const data = {
    accountId: undefined,
    error: error ? 'Error loading current account ID.' : undefined,
    isLoading,
  };

  if (!isAuthenticated || isSsr) {
    return data;
  }

  /**
   * This can actually return a value even if the user isn't logged in.
   * So we need to make sure the user's actually logged in before returning
   * the currentAccountId.
   */
  const currentAccountId = localStorage.getItem('currentAccountId');

  return {
    ...data,
    accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
  };
};
